const IconExplainer = {
  parts: [
    'container',
    'grid',
    'item',
    'iconWrapper',
    'icon',
    'content',
    'title',
    'description'
  ],
  baseStyle: {
    container: {
      display: 'flex',
      width: 'full',
      py: 20, // 80px both mobile and desktop
      px: {base: 5, md: 20},
      flexDirection: 'column',
      alignItems: {base: 'center', md: 'flex-start'},
      gap: 1, // 4px
      bg: '#32312F', // From Figma design
      position: 'relative',
    },
    grid: {
      columns: {base: 2, lg: 4}, // 2 columns mobile, 4 desktop
      spacing: {base: 12, md: 10}, // 48px mobile, 40px desktop
      width: 'full',
      maxWidth: '1149px',
      marginX: 'auto',
    },
    item: {
      flexDirection: 'column',
      alignItems: 'center',
      gap: 4, // 16px
    },
    iconWrapper: {
      display: 'flex',
      width: {base: 12, md: 16}, // 48px mobile, 64px desktop
      height: {base: 12, md: 16}, // 48px mobile, 64px desktop
      justifyContent: 'center',
      alignItems: 'center',
    },
    icon: {
      width: {base: 12, md: 16}, // 48px mobile, 64px desktop
      height: {base: 12, md: 16}, // 48px mobile, 64px desktop
      color: 'white',
    },
    content: {
      flexDirection: 'column',
      alignItems: 'center',
      gap: 2, // 8px
      alignSelf: 'stretch',
    },
    title: {
      alignSelf: 'stretch',
      color: 'white',
      textAlign: 'center',
      fontFamily: 'heading',
      fontSize: {base: 'lg', md: '1.375rem'}, // 18px mobile, 22px desktop
      fontStyle: 'normal',
      fontWeight: '500',
      lineHeight: '120%', // 21.6px mobile, 26.4px desktop
      letterSpacing: {base: '0px', md: '-0.22px'}, // 0px mobile, -0.22px desktop
    },
    description: {
      alignSelf: 'stretch',
      color: {base: 'whiteAlpha.900', md: 'whiteAlpha.800'}, // 90% mobile, 80% desktop
      textAlign: 'center',
      fontFamily: 'body',
      fontSize: {base: 'xs', md: 'md'}, // 12px mobile, 16px desktop
      fontStyle: 'normal',
      fontWeight: '400',
      lineHeight: {base: '140%', md: '160%'}, // 140% mobile (16.8px), 160% desktop (25.6px)
    },
  },
};

export default IconExplainer;
